<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.status"
                                   :options="Object.values(PartnerIncomesStatuses).filter(item => item === parseInt(item))"
                                   :custom-label="(opt) => helper.trans(`partner_incomes.status.${opt}`)"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <table class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.id') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.name') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.status') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.date') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.turnover_currency') }}</th>
                <th class="text-capitalize-first" colspan="3">{{ helper.trans('labels.revenue_total_amount') }}</th>
                <th class="text-capitalize-first" colspan="5">{{ helper.trans('labels.turnover_in_total_amount') }}</th>
                <th class="text-capitalize-first" colspan="5">{{ helper.trans('labels.turnover_out_total_amount') }}</th>
                <th class="text-capitalize-first" colspan="3">{{ helper.trans('labels.withdrawal_fee_total_amount') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.debt_amount') }}</th>
                <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.total_income_amount') }}</th>
                <th rowspan="2"></th>
              </tr>
              <tr class="bg-light">
                <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.share') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.income') }}</th>

                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_completed_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_canceled_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_net_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.share') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.income') }}</th>

                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_completed_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_canceled_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.turnover_net_amount') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.share') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.income') }}</th>

                <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.share') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.income') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in response.items" :class="{'date-group-start': isDateGroupStart(index)}">
                <td>{{ item.id }}</td>
                <td>{{ item.userName }}</td>
                <td>{{ helper.trans(`partner_incomes.status.${item.status}`)}}</td>
                <td>{{ dateHelper.format(item.date, 'YYYY-MM-DD') }}</td>
                <td>{{ turnoverCurrencyLabel(item.turnoverCurrency) }}</td>
                <td>{{ formatAmount(item.revenueTotalAmount, 2) }}</td>
                <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.revenueShare), 2) }}%</td>
                <td>{{ formatAmount(item.revenueIncomeAmount) }}</td>
                <td>{{ formatAmount(item.turnoverInTotalAmount, 2) }}</td>
                <td>{{ formatAmount(item.turnoverInCanceledAmount, 2) }}</td>
                <td>{{ formatAmount(netAmount(item.turnoverInTotalAmount, item.turnoverInCanceledAmount), 2) }}</td>
                <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.turnoverInShare), 2) }}%</td>
                <td>{{ formatAmount(item.turnoverInIncomeAmount) }}</td>
                <td>{{ formatAmount(item.turnoverOutTotalAmount, 2) }}</td>
                <td>{{ formatAmount(item.turnoverOutCanceledAmount, 2) }}</td>
                <td>{{ formatAmount(netAmount(item.turnoverOutTotalAmount, item.turnoverOutCanceledAmount), 2) }}</td>
                <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.turnoverOutShare), 2) }}%</td>
                <td>{{ formatAmount(item.turnoverOutIncomeAmount) }}</td>
                <td>{{ formatAmount(item.withdrawalFeeTotalAmount, 2) }}</td>
                <td>{{ numberFormatter.formatNumber(helper.floatToPercent(item.withdrawalFeeShare), 2) }}%</td>
                <td>{{ formatAmount(item.withdrawalFeeIncomeAmount) }}</td>
                <td :class="{'text-danger': hasAmount(item.debtAmount)}">{{ formatAmount(item.debtAmount) }}</td>
                <td>{{ formatAmount(item.totalIncomeAmount) }}</td>
                <td class="text-end">
                  <button v-if="isAdmin && item.status === PartnerIncomesStatuses.NEW" type="button" @click="processIncome(item.id)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">
                    {{helper.trans('button.process_deposit')}}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <b-pagination
                v-if="response.totalCount > response.items.length"
                v-model="page"
                :total-rows="response.totalCount"
                :per-page="response.limit"
                :limit="20"
                @update:modelValue="load()"
                prev-text="Back"
                next-text="Next"
                align="start"
                first-number
                hide-goto-end-buttons
                hide-ellipsis
            ></b-pagination>
          </div>
        </div>

      </div>
    </div>

    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<style scoped>
.date-group-start,
.date-group-start > td {
  border-top-width: 3px;
  border-top-style: solid;
}
</style>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import Multiselect from "vue-multiselect";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import {DatePicker} from "v-calendar";
import {PartnerIncomesStatuses} from "@/models/enum/PartnerIncomesStatuses";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import MoneyDTO from "@/models/MoneyDTO";

const MIXED_TURNOVER_CURRENCY = 'MIXED'

export default defineComponent({
  components: {
    ConfirmModal,
    DatePicker,
    TeamLeadMultiselect,
    PayMethodIcon,
    TraderMultiselect,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const defaultRequestDTO = {
      fromDate: null,
      toDate: null,
      status: null
    };

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      page: 1,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>,
      requestDTO: {
        ...defaultRequestDTO
      } as any
    });

    const clearFilters = async () => {
      state.requestDTO = {
        ...defaultRequestDTO
      }
    }

    // Новые денежные поля приезжают только с бэкендом BP-1437, до его выката они undefined
    const formatAmount = (value: MoneyDTO | null | undefined, subunit: number | null = null): string => {
      if (!value) {
        return ''
      }
      return numberFormatter.formatMoney(value, subunit) ?? ''
    }

    const hasAmount = (value: MoneyDTO | null | undefined): boolean => {
      return !!value && parseFloat(value.amount) !== 0
    }

    // Доля применяется к чистому обороту: (завершённые − отменённые) × share = отчисления
    const netAmount = (total: MoneyDTO | null | undefined, canceled: MoneyDTO | null | undefined): MoneyDTO | null => {
      if (!total) {
        return null
      }
      if (!canceled || total.currency !== canceled.currency) {
        return total
      }
      return helper.sub(total, canceled)
    }

    // null — строки, посчитанные до перехода на новую методику
    const turnoverCurrencyLabel = (currency: string | null | undefined): string => {
      if (!currency) {
        return '—'
      }
      return currency === MIXED_TURNOVER_CURRENCY
        ? helper.trans('labels.turnover_currency_mixed')
        : currency
    }

    // За одну дату может быть несколько строк — по строке на валюту со своей ставкой плюс общая MIXED
    const dateGroupKey = (item: any): string => {
      return `${item.userName}|${dateHelper.format(item.date, 'YYYY-MM-DD')}`
    }

    const isDateGroupStart = (index: number): boolean => {
      if (index === 0) {
        return false
      }
      return dateGroupKey(state.response.items[index]) !== dateGroupKey(state.response.items[index - 1])
    }

    const load = async () => {
      loader.value?.show()
      try {
        state.response.offset = state.response.limit * (state.page - 1)
        state.response = await api.call.statistic.partnerIncomes(state.response,
          {
            ...state.requestDTO,
            fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
            toDate: dateHelper.toUTC(state.requestDTO.toDate),
            status: state.requestDTO.status
          }
        );
      } finally {
        loader.value?.hide()
      }
    }

    const processIncome = (id: number) => {
      console.log('click')
      confirmModal.value?.show({
        title: helper.trans('labels.process_partner_income_accrual'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.processIncome(id);
            load()
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const applyFilters = async () => {
      load()
    }

    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      formatAmount,
      hasAmount,
      netAmount,
      turnoverCurrencyLabel,
      isDateGroupStart,
      UserRole,
      applyFilters,
      store,
      load,
      PartnerIncomesStatuses,
      processIncome,
      confirmModal
    }
  }
})
</script>
